module.exports = __webpack_public_path__ + "img/25.7d67ab5b.png";